<div class="bg-white mt-3 mt-xl-0 mb-4 mb-lg-0 card-top">
    <div class="container py-3 quick-actions">
        <div class="row row-cols-2 row-cols-md-4 g-3 gx-xl-0">
            <div class="col d-flex justify-content-center justify-content-lg-start">
                <a class="quick-button" [routerLink]="path.ROUTE_WALLET_HOME">
                    <div class="circle">
                        <img src="/assets/icons/home-add-funds.svg" alt="..">
                    </div>
                    Agregar fondos
                </a>
            </div>
            <div class="col d-flex justify-content-center justify-content-lg-start justify-content-xl-center justify-content-xxl-start ps-lg-4 ps-xl-0 ps-xxl-3 position-relative">
                <a class="quick-button" [routerLink]="path.ROUTE_AVAILABLE_PROJECTS_HOME">
                    <div class="circle">
                        <img src="/assets/icons/home-new-wallet.svg" alt="..">
                    </div>
                    Oportunidades
                    <div class="num-opp fw-sbold d-flex align-items-center justify-content-center" [countUp]="numberProjects | toNumber"  [options]="{ duration: 1 }" [reanimateOnClick]="false"></div>
                </a>
            </div>
            <div class="col d-flex justify-content-center justify-content-lg-end justify-content-xl-center justify-content-xxl-end pe-lg-4 pe-xl-0 pe-xxl-3">
                <a class="quick-button" [routerLink]="path.ROUTE_MOVE_HOME_V2">
                    <div class="circle">
                        <img src="/assets/icons/home-movements.svg" alt="..">
                    </div>
                    Movimientos
                </a>
            </div>
            <div class="col d-flex justify-content-center justify-content-lg-end">
                <a class="quick-button" [routerLink]="path.ROUTE_MY_INVESTMENTS_HOME">
                    <div class="circle">
                        <img src="/assets/icons/home-my-invests.svg" alt="..">
                    </div>
                    Mis inversiones
                </a>
            </div>
        </div>
    </div>
</div>